import { AccountData, EnrichedEventData } from '../../../api';

export type AgendaSession = { event: EnrichedEventData; used: number };

// Inline page lookup: importing utils/AccountUtils (getOrderPage) breaks jest on its import.meta.
export const sessionTitle = (event: EnrichedEventData, account: AccountData, language: 'he' | 'en'): string =>
  account.experiences[0]?.order_pages.find((orderPage) => orderPage.id === event.order_page_id)?.label?.[language] ??
  '';

export const sessionMatchesQuery = (title: string, query: string): boolean => {
  const needle = query.trim().toLowerCase();
  return !needle || title.toLowerCase().includes(needle);
};
